import { type StateAbbreviation } from '@repo/supergraph/marketplace/types';

import { SummaryTableSection } from '@repo/ui/roundups/components/SummaryTable/SummaryTableSection';
import { shallow } from 'zustand/shallow';
import { EmptyState } from '../OffersFilter/EmptyState';
import {
  useGetOffersFilterOffers,
  useOffersFilterStore,
} from '../roundups/components/OffersFilter/store';

export type SummaryTableHeadingProps = {
  label: string;
  labelTooltip?: string;
  path?: string;
  isRangeField?: boolean;
};

type Props = {
  sectionTitle: string;
  regionCode?: StateAbbreviation;
  maxRows?: number;
  numTruncatedRows?: number;
  allowTruncatingRows?: boolean;
  slug?: string;
  showSkeleton?: boolean;
  isMobileFirstSummaryTableExperimentActive?: boolean;
  pageUrl: string;
  shouldApplyStylingUpdates?: boolean;
  suppressApyTermPrefix?: boolean;
  isImproveQualityTrafficExperimentActive?: boolean;
  shouldDisplayWealthFrontModal?: boolean;
  allowTruncationWithFilters?: boolean;
  isAccordionActiveButtonActive?: boolean;
};

export const SummaryTableSectionWrapper = (props: Props) => {
  const isFilterLoading = useOffersFilterStore(state => state.isLoading, shallow);
  const rows = useGetOffersFilterOffers();

  return rows.length > 0 ? (
    <SummaryTableSection {...props} rows={rows} isFilterLoading={isFilterLoading} isFilterActive />
  ) : (
    <EmptyState />
  );
};
